import React, {useState, useEffect, useRef} from 'react';
import { observer } from 'mobx-react'
import './index.css';
import PopupDeleteDataset from './popup/popupDeleteDataset';
import GlobalState, {changepopupdataset, clearPoiskdataset, changepopupdeleteDataset,setShow, setShownum, nullnumpagesdatasets, changeLoadSegmentation, changePoiskdataset, changepopuprefreshDataset, changepopuprefreshDatasetcsv, adddataset, addPoiskdataset, cleardataset, changedatasetflag, minusnumpagesdatasets, plusnumpagesdatasets, changedatasettottal} from "../../stores/GlobalState";
import Pool from "../autorize/UserPool";
import Domen from "../../stores/Domen";
import lang from "../../lang"
import Loading from '../common/loading';
import LoadingCompleted from '../common/loading_completed';
const Sidebar = observer(() => {
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)
    const [deleteId, setdeleteId] = useState("");
    const [inputSearchName, setInputSearchName] = useState("");
    const [deleteIdnum, setdeleteIdnum] = useState("");
    const [textloading, setTextloadingdeploy] = useState("Loading datasets in progress ");
    const [poisk, setPoisk] = useState("");
    const [poiskApply, setpoiskApply] = useState(false)
    const [filter1, setFilter1]= useState(false)
    const [filter2, setFilter2]= useState(false)
    const [filter3, setFilter3]= useState(false)
    const [sort1, setSort1]= useState(2)
    const [sort2, setSort2]= useState(2)
    const [sort0, setSort0]= useState("")
    const [filterhover, setFilterHover] = useState("");
    const [filterhovershow, setFilterHoverShow] = useState(2);
    const [searchdataset, setSearchdataset] = useState([]);
    const [sorce, setSorce] = useState([{name: 'csv', check: false},{name: 'bigquery', check: false}]);
    const [sorcedata, setSorcedata] = useState("");
    const [height, setHeight] = useState(window.innerHeight);
    var count = Math.trunc((height*1-200)/75);
    const [countlist, setCountlist] = useState(count);
    const [activeId, setActiveId] = useState(null);
    const [activeOpen, setActiveOpen] = useState(false);
    const ref = useRef();
    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (
            (ref1.current && !ref1.current.contains(event.target))&&
            (ref2.current && !ref2.current.contains(event.target))&& 
            (ref3.current && !ref3.current.contains(event.target))  
          ) {
            setFilter1(false);
            setFilter2(false);
            setFilter3(false);
          }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    useEffect(() => {
        const updateHeight = () => setHeight(window.innerHeight);
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setActiveId(null); // закриваємо, якщо клік поза
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);



    async function getDataAttach()
    {
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        var count = Math.trunc((height*1-200)/75);
        setCountlist(count);
        const nameValues = GlobalState.poiskdataset
            .filter(item => item.check === true)
            .map(item => item.id)
            .join(',');

        const response = await fetch(Domen.url + 
            `dataset?page=`+GlobalState.numpagesdatasets+
            `&limit=`+count+sort0+
            `&filter_object_id=`+nameValues+sorcedata,
            {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status=="200")
        {
            const data = await response.json();
            changeLoadSegmentation(0);
            cleardataset();
            if(data&&data.items.length>0)
            {
                data.items?.map((n, id)=>
                    {
                        var dataset = {
                            id: n.id,
                            name: n.name,
                            source: n.source,
                            last_changes: n.upload_time,
                            rows: n.rowsCount,
                            columns: n.columnsCount,
                            object_ID: n.objectId,
                            used_in_models: n.usedInModels,
                            file_key: n.id,
                            file_name: n.file_name,
                            key_column: n.objectId,
                            status: n.status,
                            upload_time: n.upload_time,
                            uploadedAt: n.uploadedAt,
                            user_id: n.user_id,
                            columnNames: n.columnNames,
                            tag: n.tag,
                            check: false,
                            show: true
                        }
                        adddataset(dataset);
                        return "";
                    }
                )
            }
            changedatasettottal(data.total)
        }
        else
        { 
            console.log("test error")
        }

        const response0 = await fetch(Domen.url + `dataset?page=`+GlobalState.numpagesdatasets+`&limit=1000`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response0.status=="200")
        {
            const data = await response0.json();
            if(data&&data.items.length>0)
            {
                data.items?.map((n, id)=>
                    {
                        var dataset = {
                            id: n.id,
                            name: n.name,
                            source: n.source,
                            last_changes: n.upload_time,
                            rows: n.rowsCount,
                            columns: n.columnsCount,
                            object_ID: n.objectId,
                            used_in_models: n.usedInModels,
                            file_key: n.id,
                            file_name: n.file_name,
                            key_column: n.objectId,
                            status: n.status,
                            upload_time: n.upload_time,
                            uploadedAt: n.uploadedAt,
                            user_id: n.user_id,
                            columnNames: n.columnNames,
                            tag: n.tag,
                            check: false,
                            show: true
                        }
                        addPoiskdataset(dataset);
                        setShow();
                        return "";
                    }
                )
            }
        }
        else
        {
            console.log("test error")
        }
    }
    async function getDataAttach_Poisk()
    {
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        var count = Math.trunc((height*1-200)/75);
        setCountlist(count);
        const nameValues = GlobalState.poiskdataset
            .filter(item => item.check === true)  // Фільтруємо тільки елементи, де show === true
            .map(item => item.id)  // Отримуємо значення з ключем name
            .join(',');
        const response = await fetch(Domen.url + 
            `dataset?page=`+GlobalState.numpagesdatasets+
            `&limit=`+count+sort0+
            `&filter_object_id=`+nameValues,
            {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status=="200")
        {
            const data = await response.json();
            changeLoadSegmentation(0);
            cleardataset();
            if(data&&data.items.length>0)
            {
                data.items?.map((n, id)=>
                    {
                       
                        var dataset = {
                            id: n.id,
                            name: n.name,
                            source: n.source,
                            last_changes: n.upload_time,
                            rows: n.rowsCount,
                            columns: n.columnsCount,
                            object_ID: n.objectId,
                            used_in_models: n.usedInModels,
                            file_key: n.id,
                            file_name: n.file_name,
                            key_column: n.objectId,
                            status: n.status,
                            upload_time: n.upload_time,
                            uploadedAt: n.uploadedAt,
                            user_id: n.user_id,
                            columnNames: n.columnNames,
                            tag: n.tag,
                            check: false,
                            show: true
                        }
                       
                       
                        adddataset(dataset);
                        return "";
                    }
                    
                )
            }
            changedatasettottal(data.total)
        }
        else
        {
            console.log("test error")
        }  
    }
    const minusnumpagesmodels0 = () =>{
        minusnumpagesdatasets();
        getDataAttach();
    }
    const plusnumpagesmodels0= (countlist) =>{
        plusnumpagesdatasets(countlist);
        getDataAttach();
    }
    if(GlobalState.datasetflag==0){ 
        getDataAttach();
        changedatasetflag(1);
    }
    const deleteDataset = (n, id) =>{
        setdeleteId(n)
        setdeleteIdnum(id)
        changepopupdeleteDataset(n, id);
    }
    const refreshDataset = (n, id) =>{
        changepopuprefreshDataset(n, id);
    }
    const refreshDatasetcsv = (n, id) =>{
        changepopuprefreshDatasetcsv(n, id);
    }
    const checkSearchDataset = (id1)=>{
        var v = [];
        GlobalState.poiskdataset.map((n, id)=>
            id==id1?
                n.check?
                    v = [...v, 
                        {
                            id: n.id,
                            name: n.name,
                            source: n.source,
                            last_changes: n.upload_time,
                            rows: n.rowsCount,
                            columns: n.columnsCount,
                            object_ID: n.objectId,
                            used_in_models: n.usedInModels,
                            file_key: n.id,
                            file_name: n.file_name,
                            key_column: n.objectId,
                            status: n.status,
                            upload_time: n.upload_time,
                            uploadedAt: n.uploadedAt,
                            user_id: n.user_id,
                            columnNames: n.columnNames,
                            tag: n.tag,
                            check: false,
                            show: n.show
                        }
                    ]
                    :
                    v = [...v, 
                        {
                            id: n.id,
                            name: n.name,
                            source: n.source,
                            last_changes: n.upload_time,
                            rows: n.rowsCount,
                            columns: n.columnsCount,
                            object_ID: n.objectId,
                            used_in_models: n.usedInModels,
                            file_key: n.id,
                            file_name: n.file_name,
                            key_column: n.objectId,
                            status: n.status,
                            upload_time: n.upload_time,
                            uploadedAt: n.uploadedAt,
                            user_id: n.user_id,
                            columnNames: n.columnNames,
                            tag: n.tag,
                            check: true,
                            show: n.show
                        }
                    ]
            :
            v = [...v, 
                {
                    id: n.id,
                    name: n.name,
                    source: n.source,
                    last_changes: n.upload_time,
                    rows: n.rowsCount,
                    columns: n.columnsCount,
                    object_ID: n.objectId,
                    used_in_models: n.usedInModels,
                    file_key: n.id,
                    file_name: n.file_name,
                    key_column: n.objectId,
                    status: n.status,
                    upload_time: n.upload_time,
                    uploadedAt: n.uploadedAt,
                    user_id: n.user_id,
                    columnNames: n.columnNames,
                    tag: n.tag,
                    check: n.check,
                    show: n.show
                }
            ]
        )
        changePoiskdataset(v);
    }
    const applyPoisk = async(id1)=>{
        changeLoadSegmentation(1);
        nullnumpagesdatasets();
        setFilter1(false);
        setFilter2(false);
        setFilter3(false);
        var token = localStorage.getItem("token");
        const nameValues = GlobalState.poiskdataset
            .filter(item => item.check === true)  // Фільтруємо тільки елементи, де show === true
            .map(item => item.id)  // Отримуємо значення з ключем name
            .join(',');
        
        var count = Math.trunc((height*1-200)/75);
        console.log(count);
        setCountlist(count);
        const response = await fetch(Domen.url + 
            `dataset?page=`+GlobalState.numpagesdatasets+
            `&limit=`+count+sort0+
            `&filter_object_id=`+nameValues+sorcedata,
            {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status=="200")
        {
            const data = await response.json();
            cleardataset();
            if(data&&data.items.length>0)
            {
                data.items?.map((n, id)=>
                    {
                        var dataset = {
                            id: n.id,
                            name: n.name,
                            source: n.source,
                            last_changes: n.upload_time,
                            rows: n.rowsCount,
                            columns: n.columnsCount,
                            object_ID: n.objectId,
                            used_in_models: n.usedInModels,
                            file_key: n.id,
                            file_name: n.file_name,
                            key_column: n.objectId,
                            status: n.status,
                            upload_time: n.upload_time,
                            uploadedAt: n.uploadedAt,
                            user_id: n.user_id,
                            columnNames: n.columnNames,
                            tag: n.tag,
                            check: false,
                            show: true
                        }
                        adddataset(dataset);
                        return "";
                    }
                )
            }
            changedatasettottal(data.total)
            changeLoadSegmentation(0);
        }
        else
        {
            console.log("test error")
        }
        setpoiskApply(!poiskApply)
        const sorted = [...GlobalState.poiskdataset].sort((a, b) => (b.check === true) - (a.check === true));
        changePoiskdataset(sorted);
        setPoisk0("")
    }
    const checkSorceDataset = (id1)=>{
        var v = [];
        sorce.map((x, id)=>
            id==id1?
                x.check?
                    v = [...v, {name: x.name, check: false}]
                    :
                    v = [...v, {name: x.name, check: true}]
            :
            v = [...v, {name: x.name, check: x.check}]
        )
        setSorce(v);
    }
    const resetDataset = ()=>{
        setSearchdataset([])
        setpoiskApply(false);
        var v = GlobalState.poiskdataset;
        changePoiskdataset([]);
        v.map((n)=>{
            var dataset = {
                id: n.id,
                name: n.name,
                source: n.source,
                last_changes: n.upload_time,
                rows: n.rowsCount,
                columns: n.columnsCount,
                object_ID: n.objectId,
                used_in_models: n.usedInModels,
                file_key: n.id,
                file_name: n.file_name,
                key_column: n.objectId,
                status: n.status,
                upload_time: n.upload_time,
                uploadedAt: n.uploadedAt,
                user_id: n.user_id,
                columnNames: n.columnNames,
                tag: n.tag,
                check: false,
                show: true
            }
            addPoiskdataset(dataset);
        })
        getDataAttach_Poisk()
    }
    const sortDatasetAsc = async(num)=>{
        setSort1(true);
        changeLoadSegmentation(1);
        nullnumpagesdatasets();
        var filtr = "";
        var filtr2 = "";
        if(sorce[0].check)
        {
            filtr = '&filter_source=csv';
        }
        if(sorce[1].check)
        {
            filtr = '&filter_source=bigquery';
        }
        const nameValues = GlobalState.poiskdataset
            .filter(item => item.check === true)  // Фільтруємо тільки елементи, де show === true
            .map(item => item.id)  // Отримуємо значення з ключем name
            .join(',');

        if(nameValues!="")
        {
            filtr2 =  `&filter_object_id=`+nameValues;
        }
        if(num==1)
        {
            var token = localStorage.getItem("token");
            localStorage.setItem("countactivetime", Date.now());
            setSort0("&sort=name:asc");
            setSort1(0);
            setSort2(2);
            var count = Math.trunc((height*1-200)/75);
            setCountlist(count);
            const response = await fetch(Domen.url + 
                `dataset?page=`+GlobalState.numpagesdatasets+
                `&limit=`+count+
                `&sort=name:asc`+filtr+filtr2,
                
                {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            if(response.status=="200")
            {
                const data = await response.json();
                cleardataset();
                if(data&&data.items.length>0)
                {
                    data.items?.map((n, id)=>
                        {
                            var dataset = {
                                id: n.id,
                                name: n.name,
                                source: n.source,
                                last_changes: n.upload_time,
                                rows: n.rowsCount,
                                columns: n.columnsCount,
                                object_ID: n.objectId,
                                used_in_models: n.usedInModels,
                                file_key: n.id,
                                file_name: n.file_name,
                                key_column: n.objectId,
                                status: n.status,
                                upload_time: n.upload_time,
                                uploadedAt: n.uploadedAt,
                                user_id: n.user_id,
                                columnNames: n.columnNames,
                                tag: n.tag
                            }
                            adddataset(dataset);
                            return "";
                        }
                    )
                }
                changedatasettottal(data.total)
                changeLoadSegmentation(0);
            }
            else
            {
                console.log("test error")
            }
        }
        else if(num==3){
            var token = localStorage.getItem("token");
            localStorage.setItem("countactivetime", Date.now());
            var count = Math.trunc((height*1-200)/75);
            console.log(count);
            setCountlist(count);
            setSort0("&sort=uploaded_at:asc");
            setSort1(2);
            setSort2(0);
            const response = await fetch(Domen.url + 
                `dataset?page=`+GlobalState.numpagesdatasets+
                `&limit=`+count+
                `&sort=uploaded_at:asc`+filtr+filtr2,
                {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            if(response.status=="200")
            {
                const data = await response.json();
                cleardataset();
                if(data&&data.items.length>0)
                {
                    data.items?.map((n, id)=>
                        {
                            var dataset = {
                                id: n.id,
                                name: n.name,
                                source: n.source,
                                last_changes: n.upload_time,
                                rows: n.rowsCount,
                                columns: n.columnsCount,
                                object_ID: n.objectId,
                                used_in_models: n.usedInModels,
                                file_key: n.id,
                                file_name: n.file_name,
                                key_column: n.objectId,
                                status: n.status,
                                upload_time: n.upload_time,
                                uploadedAt: n.uploadedAt,
                                user_id: n.user_id,
                                columnNames: n.columnNames,
                                tag: n.tag
                            }
                            adddataset(dataset);
                            return "";
                        }
                    )
                }
                changedatasettottal(data.total)
                changeLoadSegmentation(0);
            }
            else
            {
                console.log("test error")
            }
        }

    }
    const sortDatasetDesc = async(num)=>{
        setSort1(false);
        changeLoadSegmentation(1);
        nullnumpagesdatasets();
        var filtr = "";
        var filtr2 = "";
        if(sorce[0].check)
        {
            filtr = '&filter_source=csv';
        }
        if(sorce[1].check)
        {
            filtr = '&filter_source=bigquery';
        }
        const nameValues = GlobalState.poiskdataset
            .filter(item => item.check === true)  // Фільтруємо тільки елементи, де show === true
            .map(item => item.id)  // Отримуємо значення з ключем name
            .join(',');

        if(nameValues!="")
        {
            filtr2 =  `&filter_object_id=`+nameValues;
        }
        if(num==1)
        {
            var token = localStorage.getItem("token");
            localStorage.setItem("countactivetime", Date.now());
            var count = Math.trunc((height*1-200)/75);
            console.log(count);
            setCountlist(count);
            setSort0("&sort=name:desc");
            setSort1(1);
            setSort2(2);
            const response = await fetch(Domen.url + 
                `dataset?page=`+GlobalState.numpagesdatasets+
                `&limit=`+count+
                `&sort=name:desc`+filtr+filtr2,
                {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            if(response.status=="200")
            {
                const data = await response.json();
                cleardataset();
                if(data&&data.items.length>0)
                {
                    data.items?.map((n, id)=>
                        {
                            var dataset = {
                                id: n.id,
                                name: n.name,
                                source: n.source,
                                last_changes: n.upload_time,
                                rows: n.rowsCount,
                                columns: n.columnsCount,
                                object_ID: n.objectId,
                                used_in_models: n.usedInModels,
                                file_key: n.id,
                                file_name: n.file_name,
                                key_column: n.objectId,
                                status: n.status,
                                upload_time: n.upload_time,
                                uploadedAt: n.uploadedAt,
                                user_id: n.user_id,
                                columnNames: n.columnNames,
                                tag: n.tag
                            }
                            
                            adddataset(dataset);
                            return "";
                        }
                        
                    )
                }
                changedatasettottal(data.total)
                changeLoadSegmentation(0);
            }
            else
            {
                console.log("test error")
            }
        }
        else if(num==3){
            var token = localStorage.getItem("token");
            localStorage.setItem("countactivetime", Date.now());
            var count = Math.trunc((height*1-200)/75);
            console.log(count);
            setCountlist(count);
            setSort0("&sort=uploaded_at:desc");
            setSort1(2);
            setSort2(1);
            const response = await fetch(Domen.url + 
                `dataset?page=`+GlobalState.numpagesdatasets+
                `&limit=`+count+
                `&sort=uploaded_at:desc`+filtr+filtr2,
                {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            if(response.status=="200")
            {
                const data = await response.json();
                cleardataset();
                if(data&&data.items.length>0)
                {
                    data.items?.map((n, id)=>
                        {
                            var dataset = {
                                id: n.id,
                                name: n.name,
                                source: n.source,
                                last_changes: n.upload_time,
                                rows: n.rowsCount,
                                columns: n.columnsCount,
                                object_ID: n.objectId,
                                used_in_models: n.usedInModels,
                                file_key: n.id,
                                file_name: n.file_name,
                                key_column: n.objectId,
                                status: n.status,
                                upload_time: n.upload_time,
                                uploadedAt: n.uploadedAt,
                                user_id: n.user_id,
                                columnNames: n.columnNames,
                                tag: n.tag
                            }
                            adddataset(dataset);
                            return "";
                        }
                    )
                }
                changedatasettottal(data.total)
                changeLoadSegmentation(0);
            }
            else
            {
                console.log("test error")
            }
        }
    }
    const setPoisk0 = async(a)=>{
        setPoisk(a);
        var v = GlobalState.poiskdataset;
        changePoiskdataset([]);
        setShownum(0);
        v.map((n)=>{
            if(n.name.toLowerCase().includes(a.toLowerCase())){
                
                var dataset = {
                    id: n.id,
                    name: n.name,
                    source: n.source,
                    last_changes: n.upload_time,
                    rows: n.rowsCount,
                    columns: n.columnsCount,
                    object_ID: n.objectId,
                    used_in_models: n.usedInModels,
                    file_key: n.id,
                    file_name: n.file_name,
                    key_column: n.objectId,
                    status: n.status,
                    upload_time: n.upload_time,
                    uploadedAt: n.uploadedAt,
                    user_id: n.user_id,
                    columnNames: n.columnNames,
                    tag: n.tag,
                    check: n.check,
                    show: true
                }
                setShow()
                addPoiskdataset(dataset);
            }
            else
            {
                var dataset = {
                    id: n.id,
                    name: n.name,
                    source: n.source,
                    last_changes: n.upload_time,
                    rows: n.rowsCount,
                    columns: n.columnsCount,
                    object_ID: n.objectId,
                    used_in_models: n.usedInModels,
                    file_key: n.id,
                    file_name: n.file_name,
                    key_column: n.objectId,
                    status: n.status,
                    upload_time: n.upload_time,
                    uploadedAt: n.uploadedAt,
                    user_id: n.user_id,
                    columnNames: n.columnNames,
                    tag: n.tag,
                    check: n.check,
                    show: false
                }
                addPoiskdataset(dataset);
            }
        })
    }
    const ApplySource = async()=>{
        changeLoadSegmentation(1);
        nullnumpagesdatasets();
        var filtr2 = "";
        const nameValues = GlobalState.poiskdataset
            .filter(item => item.check === true)  // Фільтруємо тільки елементи, де show === true
            .map(item => item.id)  // Отримуємо значення з ключем name
            .join(',');

        if(nameValues!="")
        {
            filtr2 =  `&filter_object_id=`+nameValues;
        }
        if((sorce[0].check&&sorce[1].check)||(!sorce[0].check&&!sorce[1].check))
        {
            var token = localStorage.getItem("token");
            localStorage.setItem("countactivetime", Date.now());

            var count = Math.trunc((height*1-200)/75);
            console.log(count);
            setCountlist(count);
            setSorcedata('&filter_source=csv,bigquery');
            const response = await fetch(Domen.url + 
                `dataset?page=`+GlobalState.numpagesdatasets+
                `&limit=`+count+sort0+
                `&filter_source=csv,bigquery`+filtr2,
                {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            if(response.status=="200")
            {
                const data = await response.json();
                cleardataset();
                if(data&&data.items.length>0)
                {
                    data.items?.map((n, id)=>
                        {
                            var dataset = {
                                id: n.id,
                                name: n.name,
                                source: n.source,
                                last_changes: n.upload_time,
                                rows: n.rowsCount,
                                columns: n.columnsCount,
                                object_ID: n.objectId,
                                used_in_models: n.usedInModels,
                                file_key: n.id,
                                file_name: n.file_name,
                                key_column: n.objectId,
                                status: n.status,
                                upload_time: n.upload_time,
                                uploadedAt: n.uploadedAt,
                                user_id: n.user_id,
                                columnNames: n.columnNames,
                                tag: n.tag,
                                check: false,
                                show: true
                            }
                            adddataset(dataset);
                            return "";
                        }
                    )
                }
                changedatasettottal(data.total)
                changeLoadSegmentation(0);
            }
            else
            {
                console.log("test error")
            }
        }
        else if(sorce[0].check)
        {
            var token = localStorage.getItem("token");
            localStorage.setItem("countactivetime", Date.now());

            var count = Math.trunc((height*1-200)/75);
            console.log(count);
            setCountlist(count);
            setSorcedata('&filter_source=csv');
            const response = await fetch(Domen.url + 
                `dataset?page=`+GlobalState.numpagesdatasets+
                `&limit=`+count+sort0+
                `&filter_source=csv`+filtr2,
                {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            if(response.status=="200")
            {
                const data = await response.json();
                cleardataset();
                if(data&&data.items.length>0)
                {
                    data.items?.map((n, id)=>
                        {
                            var dataset = {
                                id: n.id,
                                name: n.name,
                                source: n.source,
                                last_changes: n.upload_time,
                                rows: n.rowsCount,
                                columns: n.columnsCount,
                                object_ID: n.objectId,
                                used_in_models: n.usedInModels,
                                file_key: n.id,
                                file_name: n.file_name,
                                key_column: n.objectId,
                                status: n.status,
                                upload_time: n.upload_time,
                                uploadedAt: n.uploadedAt,
                                user_id: n.user_id,
                                columnNames: n.columnNames,
                                tag: n.tag,
                                check: false,
                                show: true
                            }
                            adddataset(dataset);
                            return "";
                        }
                    )
                }
                changedatasettottal(data.total)
                changeLoadSegmentation(0);
            }
            else
            {
                console.log("test error")
            }
        }
        else if(sorce[1].check)
        {
            setSorcedata('&filter_source=bigquery');
            var token = localStorage.getItem("token");
            localStorage.setItem("countactivetime", Date.now());
            var count = Math.trunc((height*1-200)/75);
            console.log(count);
            setCountlist(count);
            const response = await fetch(Domen.url + 
                `dataset?page=`+GlobalState.numpagesdatasets+
                `&limit=`+count+sort0+
                `&filter_source=bigquery`+filtr2,
                {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            if(response.status=="200")
            {
                const data = await response.json();
                cleardataset();
                if(data&&data.items.length>0)
                {
                    data.items?.map((n, id)=>
                        {
                            var dataset = {
                                id: n.id,
                                name: n.name,
                                source: n.source,
                                last_changes: n.upload_time,
                                rows: n.rowsCount,
                                columns: n.columnsCount,
                                object_ID: n.objectId,
                                used_in_models: n.usedInModels,
                                file_key: n.id,
                                file_name: n.file_name,
                                key_column: n.objectId,
                                status: n.status,
                                upload_time: n.upload_time,
                                uploadedAt: n.uploadedAt,
                                user_id: n.user_id,
                                columnNames: n.columnNames,
                                tag: n.tag,
                                check: false,
                                show: true
                                
                            }
                            adddataset(dataset);
                            return "";
                        }
                    )
                }
                changedatasettottal(data.total)
                changeLoadSegmentation(0);
            }
            else
            {
                console.log("test error")
            }    
        }
    }
    async function getDataAttachFilter(sort, name, date, source)
    {
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        var count = Math.trunc((height*1-200)/75);
        console.log(count);
        setCountlist(count);
        const response = await fetch(Domen.url + 
            `dataset?page=`+GlobalState.numpagesdatasets+
            `&limit=`+count+
            `&sort=`+sort+
            `&filter_name=`+name+
            `&filter_date=`+date+
            `&filter_source=`+source,
            {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status=="200")
        {
            const data = await response.json();
            cleardataset();
            if(data&&data.items.length>0)
            {
                data.items?.map((n, id)=>
                    {
                       
                        var dataset = {
                            id: n.id,
                            name: n.name,
                            source: n.source,
                            last_changes: n.upload_time,
                            rows: n.rowsCount,
                            columns: n.columnsCount,
                            object_ID: n.objectId,
                            used_in_models: n.usedInModels,
                            file_key: n.id,
                            file_name: n.file_name,
                            key_column: n.objectId,
                            status: n.status,
                            upload_time: n.upload_time,
                            uploadedAt: n.uploadedAt,
                            user_id: n.user_id,
                            columnNames: n.columnNames,
                            tag: n.tag
                        }
                        adddataset(dataset);
                        return "";
                    }
                )
            }
            changedatasettottal(data.total)
            changeLoadSegmentation(0);
        }
        else
        {
            console.log("test error")
        }
    }
    const setFilter01 = ()=>{
        setFilter1(!filter1);
        setFilter2(false);
        setFilter3(false);
    }
    const setFilter02 = ()=>{
        setFilter1(false);
        setFilter2(!filter2);
        setFilter3(false);
    }
    const setFilter03 = ()=>{
        setFilter1(false);
        setFilter2(false);
        setFilter3(!filter3);
    }
    const selectAll = ()=>{
        const updatedData = GlobalState.poiskdataset.map(item => 
            item.show === true ? { ...item, check: true } : item
        );
        changePoiskdataset(updatedData);
    }
    const setFilterHover0 = (a, type)=>{
        if(a.length>30){
            setFilterHover(a);
            setFilterHoverShow(type);
        }
    }

    const handleClick = (id) => {
        if (activeId === id) {
            setActiveId(null);
        } else {
            setActiveId(id);
        }
    };
    return (
        GlobalState.loadsegmentations==1?
        <div style={{marginTop:'calc(50vh - 75px)'}}>
            <Loading text = {textloading}/>
        </div>
        :
        <>
            <div className="segment datasets" >
                <div className='body-segment' style={{marginTop:"40px"}}>
                    <div className='body-segment_dataset_head'>
                        <div className='datasetnewtitle '>
                            Datasets
                        </div>
                        <div className='line_head'></div>
                        <div className='betta_line'>
                            <div className='betta new'>
                                <div className='betta_inside'>
                                    {langv?.beta?.head_text}
                                </div>
                            </div>
                        </div>
                    </div>   
                </div>
                <div className='header-segment dataset newlistdataset'>
                    <div className='title_dataset_list'>
                        <div className='left_title_dataset_list'>
                            <div className='add-segment-but dataset' onClick={changepopupdataset}>
                                <svg width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M32.4226 15C32.7799 15.6188 32.7799 16.3812 32.4226 17L25.5773 28.8564C25.2201 29.4752 24.5598 29.8564 23.8453 29.8564L10.1547 29.8564C9.44017 29.8564 8.77991 29.4752 8.42265 28.8564L1.57735 17C1.22008 16.3812 1.22008 15.6188 1.57735 15L8.42265 3.14359C8.77991 2.52479 9.44017 2.14359 10.1547 2.14359L23.8453 2.14359C24.5598 2.14359 25.2201 2.52479 25.5774 3.14359L32.4226 15Z" fill="#F5C538" stroke="#F5C538"/>
                                    <path d="M17 9V23" stroke="#020203" stroke-linecap="round"/>
                                    <path d="M17 9V23" stroke="black" stroke-opacity="0.2" stroke-linecap="round"/>
                                    <path d="M17 9V23" stroke="black" stroke-opacity="0.2" stroke-linecap="round"/>
                                    <path d="M10 16H24" stroke="#020203" stroke-linecap="round"/>
                                    <path d="M10 16H24" stroke="black" stroke-opacity="0.2" stroke-linecap="round"/>
                                    <path d="M10 16H24" stroke="black" stroke-opacity="0.2" stroke-linecap="round"/>
                                </svg>
                                {langv?.dataset?.main?.text1}
                            </div>
                        </div>
                        <div className='right_title_dataset_list'>
                            <div className='filters' onClick={()=>refreshDataset(0, "")}>
                                <span className='tooltipe'>
                                    Only BigQuery datasets can be refreshed; CSV files need to be updated manually.
                                </span>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.6">
                                    <path d="M12.0588 4.50001C8.49128 4.50001 5.55928 7.22587 5.27352 10.7011H4.55838C4.44774 10.701 4.33957 10.7339 4.24762 10.7954C4.15568 10.857 4.08411 10.9445 4.042 11.0468C3.99989 11.1491 3.98914 11.2617 4.01113 11.3701C4.03311 11.4786 4.08683 11.578 4.16547 11.6559L5.41566 12.8956C5.52018 12.9992 5.6614 13.0574 5.80857 13.0574C5.95575 13.0574 6.09697 12.9992 6.20149 12.8956L7.45168 11.6559C7.53032 11.578 7.58404 11.4786 7.60602 11.3701C7.62801 11.2617 7.61726 11.1491 7.57515 11.0468C7.53304 10.9445 7.46147 10.857 7.36953 10.7954C7.27758 10.7339 7.16941 10.701 7.05877 10.7011H6.39423C6.67701 7.85022 9.10149 5.61625 12.0588 5.61625C13.0338 5.61437 13.993 5.86261 14.8447 6.33725C15.6964 6.81188 16.4121 7.49704 16.9234 8.32723C16.9608 8.39165 17.0107 8.44793 17.0702 8.49275C17.1297 8.53757 17.1976 8.57002 17.2698 8.5882C17.3421 8.60637 17.4172 8.6099 17.4909 8.59857C17.5645 8.58725 17.6351 8.56129 17.6986 8.52224C17.762 8.4832 17.817 8.43184 17.8603 8.37121C17.9035 8.31058 17.9342 8.24189 17.9506 8.1692C17.9669 8.09652 17.9685 8.0213 17.9553 7.94798C17.9421 7.87467 17.9143 7.80474 17.8737 7.74232C17.2626 6.74991 16.4072 5.93077 15.3893 5.36314C14.3714 4.7955 13.2242 4.49833 12.0588 4.50001ZM18.5791 10.6148C18.4747 10.5116 18.3338 10.4538 18.1869 10.4538C18.0401 10.4538 17.8992 10.5116 17.7948 10.6148L16.5394 11.8546C16.4605 11.9323 16.4066 12.0318 16.3844 12.1403C16.3623 12.2488 16.3729 12.3614 16.415 12.4639C16.457 12.5663 16.5286 12.6539 16.6206 12.7156C16.7126 12.7772 16.8208 12.8101 16.9316 12.8101H17.6006C17.3163 15.6602 14.8836 17.8949 11.9122 17.8949C10.9341 17.8974 9.9717 17.6496 9.11654 17.1749C8.26138 16.7002 7.54196 16.0146 7.02677 15.1832C6.98826 15.1208 6.93785 15.0666 6.8784 15.0237C6.81894 14.9808 6.75162 14.95 6.68028 14.9331C6.60893 14.9162 6.53495 14.9135 6.46257 14.9252C6.39019 14.9369 6.32082 14.9627 6.25842 15.0012C6.1324 15.079 6.04244 15.2036 6.00832 15.3477C5.9742 15.4918 5.99871 15.6436 6.07647 15.7696C6.69171 16.763 7.55098 17.5824 8.57247 18.1498C9.59396 18.7172 10.7437 19.0138 11.9122 19.0111C15.4901 19.0111 18.4348 16.2875 18.7213 12.8101H19.4416C19.5523 12.8101 19.6606 12.7772 19.7526 12.7156C19.8446 12.6539 19.9162 12.5663 19.9582 12.4639C20.0002 12.3614 20.0109 12.2488 19.9887 12.1403C19.9666 12.0318 19.9126 11.9323 19.8338 11.8546L18.5791 10.6148Z" fill="#020203"/>
                                    </g>
                                </svg>
                                
                            </div>
                        </div>
                    </div>
                    <div className='datasethead'>
                        <div className='topfield field1 '>
                            <div className='lineflex'  ref={ref1}>
                                <label>{langv?.dataset?.main?.text11}</label>
                                <div className='openfilter'>

                                    {
                                        filter1?
                                        <>
                                            <svg onClick={()=>setFilter01(!filter1)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.75 5.83398H16.25M5.83333 10.0007H14.1667M8.33333 14.1673H11.6667" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <div className='tooltipe_filter'>
                                                <div className='sort_filter'>
                                                    <div className={sort1==0?'sort_filter_line active':'sort_filter_line'} onClick={()=>sortDatasetAsc(1)}>
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g opacity="0.6">
                                                                <path d="M8.5 4.38944L8.305 4.19444L8.5 4L8.695 4.19444L8.5 4.38944ZM8.77542 12.652C8.77542 12.725 8.7464 12.7951 8.69475 12.8467C8.6431 12.8984 8.57305 12.9274 8.5 12.9274C8.42695 12.9274 8.3569 12.8984 8.30525 12.8467C8.2536 12.7951 8.22458 12.725 8.22458 12.652H8.77542ZM5 7.49945L8.305 4.19444L8.695 4.58444L5.38999 7.88944L5 7.49945ZM8.695 4.19444L12 7.49945L11.61 7.88944L8.305 4.58444L8.695 4.19444ZM8.77542 4.38944V12.652H8.22458V4.38944H8.77542Z" fill="#020203"/>
                                                            </g>
                                                        </svg>
                                                        Sort  ascending
                                                    </div>
                                                    <div className={sort1==1?'sort_filter_line active':'sort_filter_line'} onClick={()=>sortDatasetDesc(1)}>
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g opacity="0.6">
                                                                <path d="M8.5 12.6106L8.305 12.8056L8.5 13L8.695 12.8056L8.5 12.6106ZM8.77542 4.34805C8.77542 4.275 8.7464 4.20495 8.69475 4.1533C8.6431 4.10165 8.57305 4.07263 8.5 4.07263C8.42695 4.07263 8.3569 4.10165 8.30525 4.1533C8.2536 4.20495 8.22458 4.275 8.22458 4.34805H8.77542ZM5 9.50055L8.305 12.8056L8.695 12.4156L5.38999 9.11056L5 9.50055ZM8.695 12.8056L12 9.50055L11.61 9.11056L8.305 12.4156L8.695 12.8056ZM8.77542 12.6106V4.34805H8.22458V12.6106H8.77542Z" fill="#020203"/>
                                                            </g>
                                                        </svg>
                                                        Sort  descending
                                                    </div>
                                                </div>
                                                <div className='count_filter'>
                                                    <div className='show_all_filter_left'>
                                                        <div className='show_all_filter' onClick={()=>selectAll()}>
                                                            Select all ({GlobalState.poiskdataset.length})
                                                        </div>
                                                            &nbsp;- &nbsp;
                                                        {
                                                            GlobalState.poiskdataset.find(item => item.show === true && item.check === true)?
                                                            <div className='reset_filter' onClick={()=>resetDataset()}>
                                                                Reset
                                                            </div>
                                                            :
                                                            <div className='reset_filter inactive' >
                                                                Reset
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className='show_filter'>
                                                        Show: 
                                                        {GlobalState.poiskdataset.length}
                                                    </div>
                                                </div>
                                                <div className='search_filter'>
                                                    <svg className='icon_search' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g opacity="0.6">
                                                        <path d="M10 10L8.0698 8.0698M8.0698 8.0698C8.39997 7.73963 8.66187 7.34766 8.84056 6.91628C9.01924 6.48489 9.11121 6.02254 9.11121 5.55561C9.11121 5.08868 9.01924 4.62632 8.84056 4.19493C8.66187 3.76355 8.39997 3.37158 8.0698 3.04141C7.73963 2.71124 7.34766 2.44934 6.91628 2.27065C6.48489 2.09197 6.02254 2 5.55561 2C5.08868 2 4.62632 2.09197 4.19493 2.27065C3.76355 2.44934 3.37158 2.71124 3.04141 3.04141C2.37461 3.70822 2 4.6126 2 5.55561C2 6.49861 2.37461 7.40299 3.04141 8.0698C3.70822 8.73661 4.6126 9.11121 5.55561 9.11121C6.49861 9.11121 7.40299 8.73661 8.0698 8.0698Z" stroke="#020203" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </g>
                                                    </svg>
                                                    <input 
                                                        className='search_filter_input' 
                                                        placeholder='Search'
                                                        value={poisk}
                                                        onChange={(e)=>setPoisk0(e.target.value)}  
                                                    />
                                                </div>
                                                <div className='result_filter_line_0'>
                                                    <div className='result_filter'>
                                                        {
                                                            GlobalState.poiskdataset?.map((x, id)=>
                                                                x.show?
                                                                <div className='result_filter_line' onClick={()=>checkSearchDataset(id)}>
                                                                    {
                                                                        x.check?
                                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.20833 0.5C2.49004 0.5 1.80116 0.785341 1.29325 1.29325C0.785341 1.80116 0.5 2.49004 0.5 3.20833V12.7917C0.5 13.51 0.785341 14.1988 1.29325 14.7067C1.80116 15.2147 2.49004 15.5 3.20833 15.5H12.7917C13.51 15.5 14.1988 15.2147 14.7067 14.7067C15.2147 14.1988 15.5 13.51 15.5 12.7917V3.20833C15.5 2.49004 15.2147 1.80116 14.7067 1.29325C14.1988 0.785341 13.51 0.5 12.7917 0.5H3.20833ZM1.75 3.20833C1.75 2.40333 2.40333 1.75 3.20833 1.75H12.7917C13.5967 1.75 14.25 2.40333 14.25 3.20833V12.7917C14.25 13.1784 14.0964 13.5494 13.8229 13.8229C13.5494 14.0964 13.1784 14.25 12.7917 14.25H3.20833C2.82156 14.25 2.45063 14.0964 2.17714 13.8229C1.90365 13.5494 1.75 13.1784 1.75 12.7917V3.20833ZM12.4 5.73333C12.4614 5.67611 12.5107 5.60711 12.5448 5.53045C12.579 5.45378 12.5973 5.37102 12.5988 5.2871C12.6003 5.20318 12.5849 5.11983 12.5534 5.042C12.522 4.96418 12.4752 4.89348 12.4159 4.83414C12.3565 4.77479 12.2858 4.728 12.208 4.69656C12.1302 4.66513 12.0468 4.64969 11.9629 4.65117C11.879 4.65265 11.7962 4.67102 11.7196 4.70518C11.6429 4.73934 11.5739 4.78859 11.5167 4.85L6.33083 10.03L4.48333 8.18333C4.36485 8.07293 4.20815 8.01283 4.04623 8.01569C3.88431 8.01854 3.72983 8.08414 3.61531 8.19865C3.5008 8.31316 3.43521 8.46765 3.43235 8.62956C3.4295 8.79148 3.4896 8.94819 3.6 9.06667L5.8875 11.355C6.00469 11.472 6.16354 11.5378 6.32917 11.5378C6.49479 11.5378 6.65365 11.472 6.77083 11.355L12.4 5.73333Z" fill="#34C759"></path></svg>
                                                                        :
                                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.23679 1.33203H12.7606C13.2658 1.33203 13.7503 1.53271 14.1075 1.88992C14.4647 2.24714 14.6654 2.73162 14.6654 3.23679V12.7606C14.6654 13.2658 14.4647 13.7503 14.1075 14.1075C13.7503 14.4647 13.2658 14.6654 12.7606 14.6654H3.23679C2.73162 14.6654 2.24714 14.4647 1.88992 14.1075C1.53271 13.7503 1.33203 13.2658 1.33203 12.7606V3.23679C1.33203 2.73162 1.53271 2.24714 1.88992 1.88992C2.24714 1.53271 2.73162 1.33203 3.23679 1.33203Z" stroke="#C7C7CC" stroke-linecap="round" stroke-linejoin="round"/>
                                                                        </svg>
                                                                    }
                                                                    <p onMouseEnter={()=>setFilterHover0(x.name, 1)} onMouseLeave={()=>setFilterHover0(x.name, 2)}>{x.name}</p>
                                                                </div>
                                                                :
                                                                <></>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                <div className='but_filter'>
                                                    <div className='but_filter_apply' onClick={()=>applyPoisk()}>
                                                        Apply
                                                    </div>
                                                    <div className='but_filter_cancel' onClick={()=>setFilter1(!filter1)}>
                                                        Cancel
                                                    </div>
                                                </div>
                                                {
                                                    filterhovershow==1?
                                                    <span className='tooltipe_dataset_filter'>
                                                        {filterhover}
                                                    </span>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                        </>
                                        :
                                        GlobalState.poiskdataset.filter(item => item.check === true).length>0 || sort1!=2?
                                            <svg onClick={()=>setFilter01(true)}  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.75 5.83398H16.25M5.83333 10.0007H14.1667M8.33333 14.1673H11.6667" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        :
                                        <>
                                            <svg onClick={()=>setFilter01(!filter1)} className='def_icon_f' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.75 5.83203H16.25M5.83333 9.9987H14.1667M8.33333 14.1654H11.6667" stroke="#AEAEB2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <svg onClick={()=>setFilter01(!filter1)} className='hov_icon_f' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.75 5.83203H16.25M5.83333 9.9987H14.1667M8.33333 14.1654H11.6667" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>

                                        </>
                                    }
                                </div>
                            </div>
                            <input type="text" disabled="" style={{opacity:"0", height: '0'}} class="pop-input" value="bigquery"></input>
                        </div>
                        <div className='topfield field2 '>
                            <div className='lineflex' ref={ref2}>
                                <label>{langv?.dataset?.main?.text3}</label>
                                <div className='openfilter'>
                                {
                                    filter2?
                                    <>
                                        <svg onClick={()=>setFilter02(!filter2)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.75 5.83398H16.25M5.83333 10.0007H14.1667M8.33333 14.1673H11.6667" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        <div className='tooltipe_filter'>
                                            <div className='result_filter' style={{paddingTop:"0px"}}>
                                                {
                                                    sorce?.map((x, id)=>
                                                        <div className='result_filter_line' onClick={()=>checkSorceDataset(id)}>
                                                            {
                                                                x.check?
                                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M3.20833 0.5C2.49004 0.5 1.80116 0.785341 1.29325 1.29325C0.785341 1.80116 0.5 2.49004 0.5 3.20833V12.7917C0.5 13.51 0.785341 14.1988 1.29325 14.7067C1.80116 15.2147 2.49004 15.5 3.20833 15.5H12.7917C13.51 15.5 14.1988 15.2147 14.7067 14.7067C15.2147 14.1988 15.5 13.51 15.5 12.7917V3.20833C15.5 2.49004 15.2147 1.80116 14.7067 1.29325C14.1988 0.785341 13.51 0.5 12.7917 0.5H3.20833ZM1.75 3.20833C1.75 2.40333 2.40333 1.75 3.20833 1.75H12.7917C13.5967 1.75 14.25 2.40333 14.25 3.20833V12.7917C14.25 13.1784 14.0964 13.5494 13.8229 13.8229C13.5494 14.0964 13.1784 14.25 12.7917 14.25H3.20833C2.82156 14.25 2.45063 14.0964 2.17714 13.8229C1.90365 13.5494 1.75 13.1784 1.75 12.7917V3.20833ZM12.4 5.73333C12.4614 5.67611 12.5107 5.60711 12.5448 5.53045C12.579 5.45378 12.5973 5.37102 12.5988 5.2871C12.6003 5.20318 12.5849 5.11983 12.5534 5.042C12.522 4.96418 12.4752 4.89348 12.4159 4.83414C12.3565 4.77479 12.2858 4.728 12.208 4.69656C12.1302 4.66513 12.0468 4.64969 11.9629 4.65117C11.879 4.65265 11.7962 4.67102 11.7196 4.70518C11.6429 4.73934 11.5739 4.78859 11.5167 4.85L6.33083 10.03L4.48333 8.18333C4.36485 8.07293 4.20815 8.01283 4.04623 8.01569C3.88431 8.01854 3.72983 8.08414 3.61531 8.19865C3.5008 8.31316 3.43521 8.46765 3.43235 8.62956C3.4295 8.79148 3.4896 8.94819 3.6 9.06667L5.8875 11.355C6.00469 11.472 6.16354 11.5378 6.32917 11.5378C6.49479 11.5378 6.65365 11.472 6.77083 11.355L12.4 5.73333Z" fill="#34C759"/>
                                                                </svg>
                                                                :
                                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.23679 1.33203H12.7606C13.2658 1.33203 13.7503 1.53271 14.1075 1.88992C14.4647 2.24714 14.6654 2.73162 14.6654 3.23679V12.7606C14.6654 13.2658 14.4647 13.7503 14.1075 14.1075C13.7503 14.4647 13.2658 14.6654 12.7606 14.6654H3.23679C2.73162 14.6654 2.24714 14.4647 1.88992 14.1075C1.53271 13.7503 1.33203 13.2658 1.33203 12.7606V3.23679C1.33203 2.73162 1.53271 2.24714 1.88992 1.88992C2.24714 1.53271 2.73162 1.33203 3.23679 1.33203Z" stroke="#C7C7CC" stroke-linecap="round" stroke-linejoin="round"/>
                                                                </svg>
                                                            }
                                                            <p onMouseEnter={()=>setFilterHover0(x.name, 1)} onMouseLeave={()=>setFilterHover0(x.name, 2)}>{x.name}</p>
                                                        </div>
                                                    )
                                                }  
                                            </div>
                                            <div className='but_filter'>
                                                <div className='but_filter_apply' onClick={()=>ApplySource()}>
                                                    Apply
                                                </div>
                                                <div className='but_filter_cancel' onClick={()=>setFilter2(!filter2)}>
                                                    Cancel
                                                </div>
                                            </div>
                                            {
                                                filterhovershow==1?
                                                <span className='tooltipe_dataset_filter'>
                                                    {filterhover}
                                                </span>
                                                :
                                                <></>
                                            }
                                        </div>
                                    </>
                                    :
                                    sorce.filter(item => item.check === true).length>0?
                                        <svg onClick={()=>setFilter02(true)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.75 5.83398H16.25M5.83333 10.0007H14.1667M8.33333 14.1673H11.6667" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        :
                                        <>
                                            <svg onClick={()=>setFilter02(!filter2)} className='def_icon_f' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.75 5.83203H16.25M5.83333 9.9987H14.1667M8.33333 14.1654H11.6667" stroke="#AEAEB2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <svg onClick={()=>setFilter02(!filter2)} className='hov_icon_f' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.75 5.83203H16.25M5.83333 9.9987H14.1667M8.33333 14.1654H11.6667" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>

                                        </>
                                    }
                                </div>
                            </div>
                            <input  type="text" disabled="" style={{opacity:"0", height: '0'}} class="pop-input" value="bigquery"></input>
                        </div>
                        
                        <div className='topfield field3 '>
                            <div className='lineflex' ref={ref3}>
                                <label>{langv?.dataset?.main?.text4}</label>
                                <div className='openfilter'  >
                                    {
                                        filter3?
                                        <>
                                            <svg onClick={()=>setFilter03(!filter3)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.75 5.83398H16.25M5.83333 10.0007H14.1667M8.33333 14.1673H11.6667" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <div className='tooltipe_filter'>
                                                <div className='sort_filter' style={{border:"none", paddingBottom:"0px"}}>
                                                    <div className={sort2==0?'sort_filter_line active':'sort_filter_line'} onClick={()=>sortDatasetAsc(3)}>
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g opacity="0.6">
                                                                <path d="M8.5 4.38944L8.305 4.19444L8.5 4L8.695 4.19444L8.5 4.38944ZM8.77542 12.652C8.77542 12.725 8.7464 12.7951 8.69475 12.8467C8.6431 12.8984 8.57305 12.9274 8.5 12.9274C8.42695 12.9274 8.3569 12.8984 8.30525 12.8467C8.2536 12.7951 8.22458 12.725 8.22458 12.652H8.77542ZM5 7.49945L8.305 4.19444L8.695 4.58444L5.38999 7.88944L5 7.49945ZM8.695 4.19444L12 7.49945L11.61 7.88944L8.305 4.58444L8.695 4.19444ZM8.77542 4.38944V12.652H8.22458V4.38944H8.77542Z" fill="#020203"/>
                                                            </g>
                                                        </svg>
                                                        Sort  ascending
                                                    </div>
                                                    <div className={sort2==1?'sort_filter_line active':'sort_filter_line'} style={{paddingBottom:"0px", marginBottom:"0px"}} onClick={()=>sortDatasetDesc(3)}>
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g opacity="0.6">
                                                                <path d="M8.5 12.6106L8.305 12.8056L8.5 13L8.695 12.8056L8.5 12.6106ZM8.77542 4.34805C8.77542 4.275 8.7464 4.20495 8.69475 4.1533C8.6431 4.10165 8.57305 4.07263 8.5 4.07263C8.42695 4.07263 8.3569 4.10165 8.30525 4.1533C8.2536 4.20495 8.22458 4.275 8.22458 4.34805H8.77542ZM5 9.50055L8.305 12.8056L8.695 12.4156L5.38999 9.11056L5 9.50055ZM8.695 12.8056L12 9.50055L11.61 9.11056L8.305 12.4156L8.695 12.8056ZM8.77542 12.6106V4.34805H8.22458V12.6106H8.77542Z" fill="#020203"/>
                                                            </g>
                                                        </svg>
                                                        Sort  descending
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </>
                                        :
                                        sort2!=2?
                                            <svg onClick={()=>setFilter03(true)}  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.75 5.83398H16.25M5.83333 10.0007H14.1667M8.33333 14.1673H11.6667" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        :
                                        <>
                                            <svg onClick={()=>setFilter03(!filter3)} className='def_icon_f' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.75 5.83203H16.25M5.83333 9.9987H14.1667M8.33333 14.1654H11.6667" stroke="#AEAEB2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <svg onClick={()=>setFilter03(!filter3)} className='hov_icon_f' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.75 5.83203H16.25M5.83333 9.9987H14.1667M8.33333 14.1654H11.6667" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </>
                                    }
                                </div>
                            </div>
                            <input  type="text" disabled="" style={{opacity:"0", height: '0'}} class="pop-input" value="bigquery"></input>
                        </div>
                        <div className='topfield field4 '>
                            <div className='lineflex'>
                                <label>{langv?.dataset?.main?.text5}</label>
                            </div>
                            <input  type="text" disabled="" style={{opacity:"0", height: '0'}} class="pop-input" value="bigquery"></input>
                        </div>
                        <div className='topfield field5 '>
                            <div className='lineflex'>
                                <label>{langv?.dataset?.main?.text6}</label>
                            </div>
                            <input  type="text" disabled="" style={{opacity:"0", height: '0'}} class="pop-input" value="bigquery"></input>
                        </div>
                        <div className='topfield field6 '>
                            <div className='lineflex'>
                                <label>{langv?.dataset?.main?.text7}</label>
                            </div>
                            <input  type="text" disabled="" style={{opacity:"0", height: '0'}} class="pop-input" value="bigquery"></input>
                        </div>
                        <div className='topfield field7 '>
                            <div className='lineflex'>
                                <label>{langv?.dataset?.main?.text8}</label>
                            </div>
                            <input  type="text" disabled="" style={{opacity:"0", height: '0'}} class="pop-input" value="bigquery"></input>
                        </div>
                        <div className='topfield field8 '>
                            <div className='lineflex'>
                                <label>Tag</label>
                            </div>
                            <input  type="text" disabled="" style={{opacity:"0", height: '0'}} class="pop-input" value="bigquery"></input>
                        </div>
                        <div className='tolatipa_block ' style={{opacity: 0, minWidth: '36px'}}>
                            <svg className='arica' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.6875 5.41406C10.6875 5.76216 10.8258 6.096 11.0719 6.34214C11.3181 6.58828 11.6519 6.72656 12 6.72656C12.3481 6.72656 12.6819 6.58828 12.9281 6.34214C13.1742 6.096 13.3125 5.76216 13.3125 5.41406C13.3125 5.06597 13.1742 4.73213 12.9281 4.48598C12.6819 4.23984 12.3481 4.10156 12 4.10156C11.6519 4.10156 11.3181 4.23984 11.0719 4.48598C10.8258 4.73213 10.6875 5.06597 10.6875 5.41406ZM10.6875 11.9766C10.6875 12.3247 10.8258 12.6585 11.0719 12.9046C11.3181 13.1508 11.6519 13.2891 12 13.2891C12.3481 13.2891 12.6819 13.1508 12.9281 12.9046C13.1742 12.6585 13.3125 12.3247 13.3125 11.9766C13.3125 11.6285 13.1742 11.2946 12.9281 11.0485C12.6819 10.8023 12.3481 10.6641 12 10.6641C11.6519 10.6641 11.3181 10.8023 11.0719 11.0485C10.8258 11.2946 10.6875 11.6285 10.6875 11.9766ZM10.6875 18.5391C10.6875 18.8872 10.8258 19.221 11.0719 19.4671C11.3181 19.7133 11.6519 19.8516 12 19.8516C12.3481 19.8516 12.6819 19.7133 12.9281 19.4671C13.1742 19.221 13.3125 18.8872 13.3125 18.5391C13.3125 18.191 13.1742 17.8571 12.9281 17.611C12.6819 17.3648 12.3481 17.2266 12 17.2266C11.6519 17.2266 11.3181 17.3648 11.0719 17.611C10.8258 17.8571 10.6875 18.191 10.6875 18.5391Z" fill="black"/>
                            </svg>
                        </div>
                    </div>
                    {
                        GlobalState.dataset?.map((n, id)=>
                            <div className={`datasetbody ${activeId === id ? 'open' : ''}`}>
                                <div className='topfield field1'>
                                    <input
                                        id="dataset"
                                        type="text"
                                        disabled="true"
                                        placeholder=""
                                        className="pop-input"
                                        value={n.name}
                                    />
                                </div>
                                <div className='topfield field2'>
                                    <input
                                        id="source"
                                        type="text"
                                        disabled="true"
                                        placeholder=""
                                        className="pop-input"
                                        value={n.source}
                                    />
                                </div>
                                
                                <div className='topfield field3'>
                                    <input
                                        id="lastchanges"
                                        type="text"
                                        disabled="true"
                                        placeholder=""
                                        className="pop-input"
                                        value={n.uploadedAt}
                                    />
                                </div>
                                <div className='topfield field4'>
                                    <input
                                        id="rows"
                                        type="text"
                                        disabled="true"
                                        placeholder=""
                                        className="pop-input"
                                        value={n.rows?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
                                    />
                                </div>
                                <div className='topfield field5'>
                                    <input
                                        id="columns"
                                        type="text"
                                        disabled="true"
                                        placeholder=""
                                        className="pop-input"
                                        value={n.columns}
                                    />
                                </div>
                                <div className='topfield field6'>
                                    <input
                                        id="objectid"
                                        type="text"
                                        disabled="true"
                                        placeholder=""
                                        className="pop-input"
                                        value={n.object_ID}
                                    />
                                </div>
                                <div className='topfield field7'>
                                    <input
                                        id="usedinmodels"
                                        type="text"
                                        disabled="true"
                                        placeholder=""
                                        className="pop-input"
                                        value={n.used_in_models}
                                    />
                                </div>
                                <div className='topfield field8'>
                                    <div className='tags_dataset'>
                                        {
                                            n.tag.length>0?
                                                n.tag?.map((c)=>
                                                    c=="Predict input"?
                                                    <span style={{background: "rgba(251, 227, 209, 1)"}}>{c}</span>
                                                    :
                                                    c=="Predict output"?
                                                    <span style={{background: "rgba(214, 239, 244, 1)"}}>{c}</span>
                                                    :
                                                    c=="Portrait"?
                                                    <span style={{background: "rgba(253, 243, 215, 1)"}}>{c}</span>
                                                    :
                                                    <span>{c}</span>
                                                )
                                                
                                            :
                                            <></>
                                        }
                                        
                                      
                                    </div>
                                </div>
                                <div className='tolatipa_block ' ref={activeId === id ? ref : null} onClick={() => handleClick(id)} key={id}>
                                    {
                                        GlobalState.ispopuprefreshDatasetnum!=n.id?
                                        <svg className='arica' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.6875 5.41406C10.6875 5.76216 10.8258 6.096 11.0719 6.34214C11.3181 6.58828 11.6519 6.72656 12 6.72656C12.3481 6.72656 12.6819 6.58828 12.9281 6.34214C13.1742 6.096 13.3125 5.76216 13.3125 5.41406C13.3125 5.06597 13.1742 4.73213 12.9281 4.48598C12.6819 4.23984 12.3481 4.10156 12 4.10156C11.6519 4.10156 11.3181 4.23984 11.0719 4.48598C10.8258 4.73213 10.6875 5.06597 10.6875 5.41406ZM10.6875 11.9766C10.6875 12.3247 10.8258 12.6585 11.0719 12.9046C11.3181 13.1508 11.6519 13.2891 12 13.2891C12.3481 13.2891 12.6819 13.1508 12.9281 12.9046C13.1742 12.6585 13.3125 12.3247 13.3125 11.9766C13.3125 11.6285 13.1742 11.2946 12.9281 11.0485C12.6819 10.8023 12.3481 10.6641 12 10.6641C11.6519 10.6641 11.3181 10.8023 11.0719 11.0485C10.8258 11.2946 10.6875 11.6285 10.6875 11.9766ZM10.6875 18.5391C10.6875 18.8872 10.8258 19.221 11.0719 19.4671C11.3181 19.7133 11.6519 19.8516 12 19.8516C12.3481 19.8516 12.6819 19.7133 12.9281 19.4671C13.1742 19.221 13.3125 18.8872 13.3125 18.5391C13.3125 18.191 13.1742 17.8571 12.9281 17.611C12.6819 17.3648 12.3481 17.2266 12 17.2266C11.6519 17.2266 11.3181 17.3648 11.0719 17.611C10.8258 17.8571 10.6875 18.191 10.6875 18.5391Z" fill="black"/>
                                        </svg>
                                        :
                                        <svg className='arica' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20.8C14.3339 20.8 16.5722 19.8729 18.2225 18.2225C19.8729 16.5722 20.8 14.3339 20.8 12C20.8 9.66609 19.8729 7.42778 18.2225 5.77746C16.5722 4.12714 14.3339 3.2 12 3.2C9.66609 3.2 7.42778 4.12714 5.77746 5.77746C4.12714 7.42778 3.2 9.66609 3.2 12C3.2 14.3339 4.12714 16.5722 5.77746 18.2225C7.42778 19.8729 9.66609 20.8 12 20.8ZM10.828 14.558L16.637 8.75L17.485 9.599L11.535 15.549C11.3475 15.7365 11.0932 15.8418 10.828 15.8418C10.5628 15.8418 10.3085 15.7365 10.121 15.549L7 12.426L7.849 11.577L10.829 14.557L10.828 14.558Z" fill="#34C759"/>
                                        </svg>
                                    }
                                    
                                    
                                    <div className={`tolatipa ${activeId === id ? 'open' : ''}`}  target={id}>
                                        {
                                            n.source=="bigquery"?
                                                n.tag=="Training"?
                                                <span  className='ref_tooltip inactive'>
                                                    <svg  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g opacity="0.8">
                                                        <path d="M12.0588 4.50001C8.49128 4.50001 5.55928 7.22587 5.27352 10.7011H4.55838C4.44774 10.701 4.33957 10.7339 4.24762 10.7954C4.15568 10.857 4.08411 10.9445 4.042 11.0468C3.99989 11.1491 3.98914 11.2617 4.01113 11.3701C4.03311 11.4786 4.08683 11.578 4.16547 11.6559L5.41566 12.8956C5.52018 12.9992 5.6614 13.0574 5.80857 13.0574C5.95575 13.0574 6.09697 12.9992 6.20149 12.8956L7.45168 11.6559C7.53032 11.578 7.58404 11.4786 7.60602 11.3701C7.62801 11.2617 7.61726 11.1491 7.57515 11.0468C7.53304 10.9445 7.46147 10.857 7.36953 10.7954C7.27758 10.7339 7.16941 10.701 7.05877 10.7011H6.39423C6.67701 7.85022 9.10149 5.61625 12.0588 5.61625C13.0338 5.61437 13.993 5.86261 14.8447 6.33725C15.6964 6.81188 16.4121 7.49704 16.9234 8.32723C16.9608 8.39165 17.0107 8.44793 17.0702 8.49275C17.1297 8.53757 17.1976 8.57002 17.2698 8.5882C17.3421 8.60637 17.4172 8.6099 17.4909 8.59857C17.5645 8.58725 17.6351 8.56129 17.6986 8.52224C17.762 8.4832 17.817 8.43184 17.8603 8.37121C17.9035 8.31058 17.9342 8.24189 17.9506 8.1692C17.9669 8.09652 17.9685 8.0213 17.9553 7.94798C17.9421 7.87467 17.9143 7.80474 17.8737 7.74232C17.2626 6.74991 16.4072 5.93077 15.3893 5.36314C14.3714 4.7955 13.2242 4.49833 12.0588 4.50001ZM18.5791 10.6148C18.4747 10.5116 18.3338 10.4538 18.1869 10.4538C18.0401 10.4538 17.8992 10.5116 17.7948 10.6148L16.5394 11.8546C16.4605 11.9323 16.4066 12.0318 16.3844 12.1403C16.3623 12.2488 16.3729 12.3614 16.415 12.4639C16.457 12.5663 16.5286 12.6539 16.6206 12.7156C16.7126 12.7772 16.8208 12.8101 16.9316 12.8101H17.6006C17.3163 15.6602 14.8836 17.8949 11.9122 17.8949C10.9341 17.8974 9.9717 17.6496 9.11654 17.1749C8.26138 16.7002 7.54196 16.0146 7.02677 15.1832C6.98826 15.1208 6.93785 15.0666 6.8784 15.0237C6.81894 14.9808 6.75162 14.95 6.68028 14.9331C6.60893 14.9162 6.53495 14.9135 6.46257 14.9252C6.39019 14.9369 6.32082 14.9627 6.25842 15.0012C6.1324 15.079 6.04244 15.2036 6.00832 15.3477C5.9742 15.4918 5.99871 15.6436 6.07647 15.7696C6.69171 16.763 7.55098 17.5824 8.57247 18.1498C9.59396 18.7172 10.7437 19.0138 11.9122 19.0111C15.4901 19.0111 18.4348 16.2875 18.7213 12.8101H19.4416C19.5523 12.8101 19.6606 12.7772 19.7526 12.7156C19.8446 12.6539 19.9162 12.5663 19.9582 12.4639C20.0002 12.3614 20.0109 12.2488 19.9887 12.1403C19.9666 12.0318 19.9126 11.9323 19.8338 11.8546L18.5791 10.6148Z" fill="black"/>
                                                        </g>
                                                    </svg>
                                                    Refresh
                                                </span>
                                                :
                                                <span onClick={()=>refreshDataset(n.id, n.name)} className='ref_tooltip'>
                                                    <svg  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g opacity="0.8">
                                                        <path d="M12.0588 4.50001C8.49128 4.50001 5.55928 7.22587 5.27352 10.7011H4.55838C4.44774 10.701 4.33957 10.7339 4.24762 10.7954C4.15568 10.857 4.08411 10.9445 4.042 11.0468C3.99989 11.1491 3.98914 11.2617 4.01113 11.3701C4.03311 11.4786 4.08683 11.578 4.16547 11.6559L5.41566 12.8956C5.52018 12.9992 5.6614 13.0574 5.80857 13.0574C5.95575 13.0574 6.09697 12.9992 6.20149 12.8956L7.45168 11.6559C7.53032 11.578 7.58404 11.4786 7.60602 11.3701C7.62801 11.2617 7.61726 11.1491 7.57515 11.0468C7.53304 10.9445 7.46147 10.857 7.36953 10.7954C7.27758 10.7339 7.16941 10.701 7.05877 10.7011H6.39423C6.67701 7.85022 9.10149 5.61625 12.0588 5.61625C13.0338 5.61437 13.993 5.86261 14.8447 6.33725C15.6964 6.81188 16.4121 7.49704 16.9234 8.32723C16.9608 8.39165 17.0107 8.44793 17.0702 8.49275C17.1297 8.53757 17.1976 8.57002 17.2698 8.5882C17.3421 8.60637 17.4172 8.6099 17.4909 8.59857C17.5645 8.58725 17.6351 8.56129 17.6986 8.52224C17.762 8.4832 17.817 8.43184 17.8603 8.37121C17.9035 8.31058 17.9342 8.24189 17.9506 8.1692C17.9669 8.09652 17.9685 8.0213 17.9553 7.94798C17.9421 7.87467 17.9143 7.80474 17.8737 7.74232C17.2626 6.74991 16.4072 5.93077 15.3893 5.36314C14.3714 4.7955 13.2242 4.49833 12.0588 4.50001ZM18.5791 10.6148C18.4747 10.5116 18.3338 10.4538 18.1869 10.4538C18.0401 10.4538 17.8992 10.5116 17.7948 10.6148L16.5394 11.8546C16.4605 11.9323 16.4066 12.0318 16.3844 12.1403C16.3623 12.2488 16.3729 12.3614 16.415 12.4639C16.457 12.5663 16.5286 12.6539 16.6206 12.7156C16.7126 12.7772 16.8208 12.8101 16.9316 12.8101H17.6006C17.3163 15.6602 14.8836 17.8949 11.9122 17.8949C10.9341 17.8974 9.9717 17.6496 9.11654 17.1749C8.26138 16.7002 7.54196 16.0146 7.02677 15.1832C6.98826 15.1208 6.93785 15.0666 6.8784 15.0237C6.81894 14.9808 6.75162 14.95 6.68028 14.9331C6.60893 14.9162 6.53495 14.9135 6.46257 14.9252C6.39019 14.9369 6.32082 14.9627 6.25842 15.0012C6.1324 15.079 6.04244 15.2036 6.00832 15.3477C5.9742 15.4918 5.99871 15.6436 6.07647 15.7696C6.69171 16.763 7.55098 17.5824 8.57247 18.1498C9.59396 18.7172 10.7437 19.0138 11.9122 19.0111C15.4901 19.0111 18.4348 16.2875 18.7213 12.8101H19.4416C19.5523 12.8101 19.6606 12.7772 19.7526 12.7156C19.8446 12.6539 19.9162 12.5663 19.9582 12.4639C20.0002 12.3614 20.0109 12.2488 19.9887 12.1403C19.9666 12.0318 19.9126 11.9323 19.8338 11.8546L18.5791 10.6148Z" fill="black"/>
                                                        </g>
                                                    </svg>
                                                    Refresh
                                                </span>
                                            :
                                            n.tag=="Training"?
                                                <span className='ref_tooltip inactive'>
                                                    <svg  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g opacity="0.8">
                                                        <path d="M12.0588 4.50001C8.49128 4.50001 5.55928 7.22587 5.27352 10.7011H4.55838C4.44774 10.701 4.33957 10.7339 4.24762 10.7954C4.15568 10.857 4.08411 10.9445 4.042 11.0468C3.99989 11.1491 3.98914 11.2617 4.01113 11.3701C4.03311 11.4786 4.08683 11.578 4.16547 11.6559L5.41566 12.8956C5.52018 12.9992 5.6614 13.0574 5.80857 13.0574C5.95575 13.0574 6.09697 12.9992 6.20149 12.8956L7.45168 11.6559C7.53032 11.578 7.58404 11.4786 7.60602 11.3701C7.62801 11.2617 7.61726 11.1491 7.57515 11.0468C7.53304 10.9445 7.46147 10.857 7.36953 10.7954C7.27758 10.7339 7.16941 10.701 7.05877 10.7011H6.39423C6.67701 7.85022 9.10149 5.61625 12.0588 5.61625C13.0338 5.61437 13.993 5.86261 14.8447 6.33725C15.6964 6.81188 16.4121 7.49704 16.9234 8.32723C16.9608 8.39165 17.0107 8.44793 17.0702 8.49275C17.1297 8.53757 17.1976 8.57002 17.2698 8.5882C17.3421 8.60637 17.4172 8.6099 17.4909 8.59857C17.5645 8.58725 17.6351 8.56129 17.6986 8.52224C17.762 8.4832 17.817 8.43184 17.8603 8.37121C17.9035 8.31058 17.9342 8.24189 17.9506 8.1692C17.9669 8.09652 17.9685 8.0213 17.9553 7.94798C17.9421 7.87467 17.9143 7.80474 17.8737 7.74232C17.2626 6.74991 16.4072 5.93077 15.3893 5.36314C14.3714 4.7955 13.2242 4.49833 12.0588 4.50001ZM18.5791 10.6148C18.4747 10.5116 18.3338 10.4538 18.1869 10.4538C18.0401 10.4538 17.8992 10.5116 17.7948 10.6148L16.5394 11.8546C16.4605 11.9323 16.4066 12.0318 16.3844 12.1403C16.3623 12.2488 16.3729 12.3614 16.415 12.4639C16.457 12.5663 16.5286 12.6539 16.6206 12.7156C16.7126 12.7772 16.8208 12.8101 16.9316 12.8101H17.6006C17.3163 15.6602 14.8836 17.8949 11.9122 17.8949C10.9341 17.8974 9.9717 17.6496 9.11654 17.1749C8.26138 16.7002 7.54196 16.0146 7.02677 15.1832C6.98826 15.1208 6.93785 15.0666 6.8784 15.0237C6.81894 14.9808 6.75162 14.95 6.68028 14.9331C6.60893 14.9162 6.53495 14.9135 6.46257 14.9252C6.39019 14.9369 6.32082 14.9627 6.25842 15.0012C6.1324 15.079 6.04244 15.2036 6.00832 15.3477C5.9742 15.4918 5.99871 15.6436 6.07647 15.7696C6.69171 16.763 7.55098 17.5824 8.57247 18.1498C9.59396 18.7172 10.7437 19.0138 11.9122 19.0111C15.4901 19.0111 18.4348 16.2875 18.7213 12.8101H19.4416C19.5523 12.8101 19.6606 12.7772 19.7526 12.7156C19.8446 12.6539 19.9162 12.5663 19.9582 12.4639C20.0002 12.3614 20.0109 12.2488 19.9887 12.1403C19.9666 12.0318 19.9126 11.9323 19.8338 11.8546L18.5791 10.6148Z" fill="black"/>
                                                        </g>
                                                    </svg>
                                                    Refresh
                                                </span>
                                                :
                                                <span onClick={()=>refreshDatasetcsv(n.id, n.name)} className='ref_tooltip'>
                                                    <svg  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g opacity="0.8">
                                                        <path d="M12.0588 4.50001C8.49128 4.50001 5.55928 7.22587 5.27352 10.7011H4.55838C4.44774 10.701 4.33957 10.7339 4.24762 10.7954C4.15568 10.857 4.08411 10.9445 4.042 11.0468C3.99989 11.1491 3.98914 11.2617 4.01113 11.3701C4.03311 11.4786 4.08683 11.578 4.16547 11.6559L5.41566 12.8956C5.52018 12.9992 5.6614 13.0574 5.80857 13.0574C5.95575 13.0574 6.09697 12.9992 6.20149 12.8956L7.45168 11.6559C7.53032 11.578 7.58404 11.4786 7.60602 11.3701C7.62801 11.2617 7.61726 11.1491 7.57515 11.0468C7.53304 10.9445 7.46147 10.857 7.36953 10.7954C7.27758 10.7339 7.16941 10.701 7.05877 10.7011H6.39423C6.67701 7.85022 9.10149 5.61625 12.0588 5.61625C13.0338 5.61437 13.993 5.86261 14.8447 6.33725C15.6964 6.81188 16.4121 7.49704 16.9234 8.32723C16.9608 8.39165 17.0107 8.44793 17.0702 8.49275C17.1297 8.53757 17.1976 8.57002 17.2698 8.5882C17.3421 8.60637 17.4172 8.6099 17.4909 8.59857C17.5645 8.58725 17.6351 8.56129 17.6986 8.52224C17.762 8.4832 17.817 8.43184 17.8603 8.37121C17.9035 8.31058 17.9342 8.24189 17.9506 8.1692C17.9669 8.09652 17.9685 8.0213 17.9553 7.94798C17.9421 7.87467 17.9143 7.80474 17.8737 7.74232C17.2626 6.74991 16.4072 5.93077 15.3893 5.36314C14.3714 4.7955 13.2242 4.49833 12.0588 4.50001ZM18.5791 10.6148C18.4747 10.5116 18.3338 10.4538 18.1869 10.4538C18.0401 10.4538 17.8992 10.5116 17.7948 10.6148L16.5394 11.8546C16.4605 11.9323 16.4066 12.0318 16.3844 12.1403C16.3623 12.2488 16.3729 12.3614 16.415 12.4639C16.457 12.5663 16.5286 12.6539 16.6206 12.7156C16.7126 12.7772 16.8208 12.8101 16.9316 12.8101H17.6006C17.3163 15.6602 14.8836 17.8949 11.9122 17.8949C10.9341 17.8974 9.9717 17.6496 9.11654 17.1749C8.26138 16.7002 7.54196 16.0146 7.02677 15.1832C6.98826 15.1208 6.93785 15.0666 6.8784 15.0237C6.81894 14.9808 6.75162 14.95 6.68028 14.9331C6.60893 14.9162 6.53495 14.9135 6.46257 14.9252C6.39019 14.9369 6.32082 14.9627 6.25842 15.0012C6.1324 15.079 6.04244 15.2036 6.00832 15.3477C5.9742 15.4918 5.99871 15.6436 6.07647 15.7696C6.69171 16.763 7.55098 17.5824 8.57247 18.1498C9.59396 18.7172 10.7437 19.0138 11.9122 19.0111C15.4901 19.0111 18.4348 16.2875 18.7213 12.8101H19.4416C19.5523 12.8101 19.6606 12.7772 19.7526 12.7156C19.8446 12.6539 19.9162 12.5663 19.9582 12.4639C20.0002 12.3614 20.0109 12.2488 19.9887 12.1403C19.9666 12.0318 19.9126 11.9323 19.8338 11.8546L18.5791 10.6148Z" fill="black"/>
                                                        </g>
                                                    </svg>
                                                    Refresh
                                                </span>
                                        }
                                        
                                        <span className='del_tooltip' onClick={()=>deleteDataset(n.id, id)}>
                                            <svg  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.8">
                                                <path d="M10.4 6.8H13.6C13.6 6.37565 13.4314 5.96869 13.1314 5.66863C12.8313 5.36857 12.4243 5.2 12 5.2C11.5757 5.2 11.1687 5.36857 10.8686 5.66863C10.5686 5.96869 10.4 6.37565 10.4 6.8ZM9.2 6.8C9.2 6.4323 9.27242 6.0682 9.41314 5.72849C9.55385 5.38877 9.7601 5.08011 10.0201 4.8201C10.2801 4.5601 10.5888 4.35385 10.9285 4.21314C11.2682 4.07242 11.6323 4 12 4C12.3677 4 12.7318 4.07242 13.0715 4.21314C13.4112 4.35385 13.7199 4.5601 13.9799 4.8201C14.2399 5.08011 14.4461 5.38877 14.5869 5.72849C14.7276 6.0682 14.8 6.4323 14.8 6.8H19.4C19.5591 6.8 19.7117 6.86321 19.8243 6.97574C19.9368 7.08826 20 7.24087 20 7.4C20 7.55913 19.9368 7.71174 19.8243 7.82426C19.7117 7.93679 19.5591 8 19.4 8H18.344L17.408 17.6888C17.3362 18.4312 16.9904 19.1202 16.4381 19.6215C15.8859 20.1227 15.1666 20.4003 14.4208 20.4H9.5792C8.83349 20.4001 8.11448 20.1224 7.56236 19.6212C7.01024 19.1199 6.66459 18.431 6.5928 17.6888L5.656 8H4.6C4.44087 8 4.28826 7.93679 4.17574 7.82426C4.06321 7.71174 4 7.55913 4 7.4C4 7.24087 4.06321 7.08826 4.17574 6.97574C4.28826 6.86321 4.44087 6.8 4.6 6.8H9.2ZM10.8 10.6C10.8 10.4409 10.7368 10.2883 10.6243 10.1757C10.5117 10.0632 10.3591 10 10.2 10C10.0409 10 9.88826 10.0632 9.77574 10.1757C9.66321 10.2883 9.6 10.4409 9.6 10.6V16.6C9.6 16.7591 9.66321 16.9117 9.77574 17.0243C9.88826 17.1368 10.0409 17.2 10.2 17.2C10.3591 17.2 10.5117 17.1368 10.6243 17.0243C10.7368 16.9117 10.8 16.7591 10.8 16.6V10.6ZM13.8 10C13.9591 10 14.1117 10.0632 14.2243 10.1757C14.3368 10.2883 14.4 10.4409 14.4 10.6V16.6C14.4 16.7591 14.3368 16.9117 14.2243 17.0243C14.1117 17.1368 13.9591 17.2 13.8 17.2C13.6409 17.2 13.4883 17.1368 13.3757 17.0243C13.2632 16.9117 13.2 16.7591 13.2 16.6V10.6C13.2 10.4409 13.2632 10.2883 13.3757 10.1757C13.4883 10.0632 13.6409 10 13.8 10ZM7.7872 17.5736C7.83035 18.0189 8.0378 18.4322 8.36909 18.7329C8.70039 19.0336 9.1318 19.2001 9.5792 19.2H14.4208C14.8682 19.2001 15.2996 19.0336 15.6309 18.7329C15.9622 18.4322 16.1697 18.0189 16.2128 17.5736L17.1392 8H6.8608L7.7872 17.5736Z" fill="#FF3B30"/>
                                                </g>
                                            </svg>
                                            Delete
                                        </span>

                                    </div>
                                </div>
                            

                            </div>
                            
                        )
                        
                    }
                    
                </div>
            </div>
            <div className='pagination_line'>
                <div className='countpagepagination'>
                    {langv?.dataset?.main?.text9}  {GlobalState.datasetstottal>0?(GlobalState.numpagesdatasets*1-1)*countlist+1:"0"} -&nbsp;
                    
                    {
                        GlobalState.numpagesdatasets*countlist<GlobalState.datasetstottal?
                        GlobalState.numpagesdatasets*countlist
                        :
                        GlobalState.datasetstottal
                    }
                    &nbsp;of {GlobalState.datasetstottal} {langv?.dataset?.main?.text10} 
                </div>
            
                <div className='pagination pagdatasets'>
                    {
                        GlobalState.numpagesdatasets<2?
                        <div className='arrowP cursorenone' >

                            <svg className='cursorenone' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.1">
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203"/>
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="#020203"/>
                                <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                                <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                                </g>
                            </svg>

                            


                        </div>
                        :
                        <div className='arrowP' onClick={()=>minusnumpagesmodels0()}>
                            <svg className='def_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.4">
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203"/>
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="#020203"/>
                                <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                                <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                                </g>
                            </svg>

                            <svg className='hov_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="url(#paint0_linear_3491_117361)"/>
                                <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="#020203"/>
                                <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                                <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                                <defs>
                                <linearGradient id="paint0_linear_3491_117361" x1="1" y1="13" x2="45" y2="13" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#F5C538"/>
                                <stop offset="1" stop-color="#F5C538" stop-opacity="0"/>
                                </linearGradient>
                                </defs>
                            </svg>
                        </div>
                    }
                    
                    <div className='pagenum'>

                        {
                            GlobalState.datasetstottal<countlist?
                                <span>01</span>
                                : 
                                    GlobalState.numpagesdatasets<10?
                                        <span>{"0"+GlobalState.numpagesdatasets}</span>
                                        :
                                        <span>{GlobalState.numpagesdatasets}</span>
                        }
                        / 
                        {
                            GlobalState.datasetstottal<countlist?
                            "01":
                            Math.ceil(GlobalState.datasetstottal/countlist)<countlist?
                            "0"+Math.ceil(GlobalState.datasetstottal/countlist):
                            Math.ceil(GlobalState.datasetstottal/countlist)
                        }
                    </div>
                    
                        {
                            GlobalState.datasetstottal<countlist?
                            <div className='arrowP cursorenone'>
                                <svg className='cursorenone' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.1">
                                    <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203"/>
                                    <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                    <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                    <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="#020203"/>
                                    <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                    <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                    </g>
                                </svg>
                            </div>
                            :
                            GlobalState.numpagesdatasets==Math.ceil(GlobalState.datasetstottal/countlist)?
                            <div className='arrowP cursorenone'>
                                <svg className='cursorenone' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.1">
                                    <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203"/>
                                    <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                    <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                    <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="#020203"/>
                                    <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                    <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                    </g>
                                </svg>
                            </div>
                            :
                            <div className='arrowP' onClick={()=>plusnumpagesmodels0(countlist)}>
                                <svg className='def_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.4">
                                    <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203"/>
                                    <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                    <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                    <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="#020203"/>
                                    <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                    <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                    </g>
                                </svg>
                                <svg className='hov_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="url(#paint0_linear_3491_117355)"/>
                                    <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="#020203"/>
                                    <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                    <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                    <defs>
                                    <linearGradient id="paint0_linear_3491_117355" x1="53" y1="13" x2="10" y2="13" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#F5C538"/>
                                    <stop offset="1" stop-color="#F5C538" stop-opacity="0"/>
                                    </linearGradient>
                                    </defs>
                                </svg>
                            </div>

                        }
                        
                    
                </div>
            </div>
         </>
    );
})
export default Sidebar;